module.exports = __webpack_public_path__ + "static/media/anna.6f32b95a.png";